export default class  PageView {

    constructor() {
        this.body = document.body;
        this.id = document.body.dataset.postid
        if(!this.id) return;

        this.sendPageAction(this.id, 'viewpage');
        this.setEvents();
    }

    sendPageAction( id, action) {


        let actionStorage = localStorage.getItem('vo-' + action);
            actionStorage = actionStorage ? JSON.parse(actionStorage) : [];
            actionStorage = actionStorage.map((x) => parseInt(x))

        if(actionStorage.includes(parseInt(id))) return;

        actionStorage.push(parseInt(id));
        localStorage.setItem('vo-' + action, JSON.stringify(actionStorage));

        const data = new FormData();
        data.append( 'action', action );
        data.append( 'postid', id);
        
        fetch(ajaxurl, {
            method: "POST",
            credentials: 'same-origin',
            body: data
        })
        .then((response) => response.json())
        .then((data) => {
            if (data) {

            }
        })
        .catch((error) => {
            console.log('[pageview error] : ' + action);
            console.error(error);
        });
    }

    setEvents(){
        window.addEventListener('vegout-share', () => { this.sendPageAction(this.id, 'sharepage'); });
        window.addEventListener('vegout-like', () => { this.sendPageAction(this.id, 'likepage'); });
    }

}